import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  getDocs,
  updateDoc,
  deleteDoc,
  doc
} from 'firebase/firestore';
import AdminSidebar from '../components/AdminSidebar';
import '../style/common.css';
import './ManageUsers.css'; 

function ManageUsers() {
  const [users, setUsers] = useState([]);
  const [editingName, setEditingName] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      const snap = await getDocs(collection(db, 'users'));
      const userList = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setUsers(userList.filter(u => u.role === 'pm')); // Only PMs
      setLoading(false);
    };
    fetchUsers();
  }, []);

  const handleNameChange = (id, name) => {
    setEditingName(prev => ({ ...prev, [id]: name }));
  };

  const handleNameSave = async (id) => {
    const newName = editingName[id];
    if (!newName.trim()) return alert('Name cannot be empty');

    try {
      const password = newName + '123';
      await updateDoc(doc(db, 'users', id), { name: newName, password });
      setUsers(prev => prev.map(u => u.id === id ? { ...u, name: newName, password } : u));
      alert(`Name & password updated. Password is now "${password}"`);
    } catch (err) {
      console.error(err);
      alert('Failed to update name');
    }
  };

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are you sure you want to delete this user?");
    if (!confirm) return;

    try {
      await deleteDoc(doc(db, 'users', id));
      setUsers(prev => prev.filter(u => u.id !== id));
      alert('User deleted successfully');
    } catch (err) {
      console.error(err);
      alert('Failed to delete user');
    }
  };

  return (
    <div className="dashboard-wrapper">
      <AdminSidebar />
      <div className="dashboard-content">
        <h2 className="page-title">Manage Project Managers</h2>

        {loading ? (
          <p>Loading users...</p>
        ) : users.length === 0 ? (
          <p>No Project Managers found.</p>
        ) : (
          <div className="user-list">
            {users.map(u => (
              <div key={u.id} className="user-card">
                <div className="user-info">
                  <p><strong>Email:</strong> {u.email}</p>
                  <label><strong>Edit Name:</strong></label>
                  <input
                    type="text"
                    className="input-field"
                    value={editingName[u.id] !== undefined ? editingName[u.id] : u.name}
                    onChange={(e) => handleNameChange(u.id, e.target.value)}
                  />
                  <p><strong>Password:</strong> {u.password || (u.name ? u.name + '123' : 'Not set')}</p>
                </div>
                <div className="button-group">
                  <button className="submit-btn" onClick={() => handleNameSave(u.id)}>Update Name</button>
                  <button className="delete-btn" onClick={() => handleDelete(u.id)}>Delete User</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ManageUsers;
